<template>
  <span>
    <div class="background-wallpaper" style="background-image: url(https://res.cloudinary.com/hyimvofxm/image/upload/v1636737932/9_68caa27a4e.png);"></div>
    <div class="banner" style="background-image:url(../static/img/about.jpg)">
    </div>
    <section class="spaced">
      <div class="container content">
        <div class="column c12 text-center">
          <h1 class="spaced">ABOUT US</h1>
        </div>
        <div class="column c8 push-center" style="padding:20px">
          <p class="text-center">
            Patronus Records was founded in 2018. The initial idea was to build
            the record and event-label together in joined forces. Part of the
            team was and still is: Cedric Marugg aka Xed as the head of the
            endeavour, Mihel Kreiliger aka Mirror Engine and Jamin Coray aka
            Yaroc/Sel7am as sustaining forces.
          </p>
          <p class="text-center">
            Having successfully organized many beautiful events and released
            countless amazing music by talented, upcoming as well as established
            artists we continue on gathering experience to make our own
            footprint in rave-culture. All of this, we try to fuel by the ideals
            and values we live by, in hope to create something beautiful and
            meaningful. Nothing is more precious than being present in the
            moment and experiencing it so it can fuel and inspire taking on the
            challenges of everyday live. Putting strong emphasis on a peaceful
            and joyful atmosphere in the scene, we strive to compensate the
            artists as much as possible for their essential contribution and
            offer all the work to elevate the arts to the heights they deserve.
            We highly value structured and clean events for guest, artist and
            environment alike and without compromise.
          </p>
          <p class="text-center">
            <strong>
              Being a reliable partner and provider is an invaluable trait we
              are known for and always try to improve on. Looking into the
              future with hope, energy and enthusiasm is the only way.
            </strong>
          </p>
        </div>
      </div>
    </section>
  </span>
</template>
<script>
export default {
  title: 'Patronus Records - About Us'
}
</script>
<style scoped>
.banner {
    width: 100vw;
    /* height: 420px; */
    padding-bottom:500px;
    display: inline-block;
    vertical-align: top;
    position: relative;
    overflow: hidden;
    background-position: top center;
    background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/pages/about.vue